import { render, staticRenderFns } from "./deptTutorials.vue?vue&type=template&id=702d5b8a&scoped=true"
import script from "./deptTutorials.vue?vue&type=script&lang=js"
export * from "./deptTutorials.vue?vue&type=script&lang=js"
import style0 from "./deptTutorials.vue?vue&type=style&index=0&id=702d5b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702d5b8a",
  null
  
)

export default component.exports